import { useContext } from 'react';
import { ConsentContext, type ConsentContextValue } from './consentContextValue';

export function useConsent(): ConsentContextValue {
  const ctx = useContext(ConsentContext);
  if (!ctx) throw new Error('useConsent must be used within ConsentProvider');
  return ctx;
}

export function useConsentOptional(): ConsentContextValue | null {
  return useContext(ConsentContext);
}
